import { render, staticRenderFns } from "./yuyuePaiBan.vue?vue&type=template&id=62ef50a9&scoped=true&"
import script from "./yuyuePaiBan.vue?vue&type=script&lang=js&"
export * from "./yuyuePaiBan.vue?vue&type=script&lang=js&"
import style0 from "./yuyuePaiBan.vue?vue&type=style&index=0&id=62ef50a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef50a9",
  null
  
)

export default component.exports